/**
 * B973 — a type the channel does not price is not offered. catalog.list's
 * card already tells the truth (a variant with no `displayPrice` has no
 * effective price on this channel at this moment — the same resolver the
 * cart quote runs), so offering it sold a dead end: the total vanished and
 * the kernel refused the add. Applied at the ONE seam every buyer face reads
 * (the products state), never per stepper.
 *
 * A product priced NOWHERE keeps its types: that is B20b's honest-absence
 * face (no figure, never a guess), and the kernel refuses it in words.
 */
import type { ProductSummary } from "../ui/screens.js";

export function sellableCards(list: readonly ProductSummary[]): ProductSummary[] {
  return list.map((card) => {
    const priced = card.variants.filter((v) => v.displayPrice !== undefined);
    if (priced.length === 0 || priced.length === card.variants.length) return card;
    return { ...card, variants: priced };
  });
}
